// extracted by mini-css-extract-plugin
module.exports = {"sliderMobileWrapper":"fixedSlider_sliderMobileWrapper__w8pjJ","sliderWrapper":"fixedSlider_sliderWrapper___I5ko"};